module.exports = __webpack_public_path__ + "img/app5.f4af73b1.png";